export const TestResultsActions = {
	GET_TEST_REPORT_USERS: 'GET_TEST_REPORT_USERS',
	GET_TEST_REPORT_USERS_SUCCESS: 'GET_TEST_REPORT_USERS_SUCCESS',
	GET_TEST_REPORT_USERS_FAIL: 'GET_TEST_REPORT_USERS_FAIL',
	GET_USER_TEST_REPORT: 'GET_USER_TEST_REPORT',
	GET_USER_TEST_REPORT_SUCCESS: 'GET_USER_TEST_REPORT_SUCCESS',
	GET_USER_TEST_REPORT_FAIL: 'GET_USER_TEST_REPORT_FAIL',
	CLEAR_SESSION: 'CLEAR_SESSION',
};
